import React, { Fragment, useContext, useState, useMemo, useEffect, useLayoutEffect } from 'react';
import { ARROW_STYLE, POINT_STYLE, Swiper } from '../../Component/Swiper/Swiper';
import { SOCIAL_MEDIA_LOGOS, STYLE_TYPE, contact, imageDomain, homePageContact, SOCIAL_MEDIA_LINKS, SOCIAL_MEDIA_TYPE } from '../../Utils/magicStrings';
import { HomeWrapper, AboutUsMainText, AboutUsSubText, AboutUsWrapper, AboutUsTextWrapper, 
    SwiperBackground, SwiperWrapper, TitleText, CollectionWrapper, 
    CardWrapper, CardPicWrapper, TagsWrapper, 
    CardTag, CardTextWrapper, HoverCover, CollectionPageWrapper,
    ExperienceWrapper, ExperienceCardWrapper, ExCardPicture, Background, ExKeyWord,
    ExLocation, ExText, ExTitle, ExButton, ExperienceSwiper, QAWrapper, QAText, QAGuide,
    Answer, QuestionButton, Question, QABlockWrapper, ContactWrapper, ContactIconWrapper,
    Toptips, SeeMore, RightTips, CardTopTips, YelloArrow
} from './HomeStyle';
import { styleContextApp } from '../StyleContext';
import { Link, useLocation } from 'react-router-dom';
import { Header } from '../../Component/Header/Header';
import { Footer } from '../../Component/Footer/Footer';
import { fetchData } from '../../Utils/fetch';
import topBig from './BigTop.png';
import topSmall from './SmallTop.png';
import yellow from './yellow.png';
import { Add, Clear, WindowSharp } from '@mui/icons-material';
import { WechatWindow } from '../Reserve/ReserveStyle';
import wechat from '../Reserve/wechat.png';
import { Modal } from '../../Component/Modal/Modal';

export const Home = ({data}) => {
    const [ homePageData, setHomePageData ] = useState(null);
    const styleType = useContext(styleContextApp);
    const location = useLocation();

    useEffect(() => {
        getData();
    }, []);

    useLayoutEffect(() => {
        if(!homePageData) {}
        if(location.state?.aim && document.getElementById(location.state.aim)) {
            document.documentElement.scrollTop = document.getElementById(location.state?.aim).getBoundingClientRect().y + window.scrollY - (location.state.gap);
        }
    }, [location.state, homePageData])

    const getData = async () =>  {
        try {
            const data = await fetchData('top');
            setHomePageData(data);
        } catch(e) {
            setHomePageData('error');
        }
    }

    if(!homePageData) {
        return null;
    }

    const headerTitle = (() => {
        if(styleType !== STYLE_TYPE.MOBILE) {
            return '這裡的每一間旅舍，\n都傳遞著土地的故事、和對生活的熱愛。'
        } else {
            return '這裡的每一間旅舍，\n都傳遞著土地的故事\n和對生活的熱愛。'
        }
    })(styleType);



    return (
        <HomeWrapper styleType={styleType}>
            <Link to='/explore'>
                <Toptips id='toptip' color={'#B69A67'} styleType={styleType}>
                        <span>{'點此深度搜索'}</span>
                        <img id={'top'} src={styleType === STYLE_TYPE.MOBILE ? topSmall : topBig}  alt=''/>
                </Toptips>
            </Link>
            <Header 
                title={homePageData?.primaryList.filter(e => e.title)[0].title || headerTitle}
                styleType={styleType} 
                hasMarginTop={true} 
                pictures={homePageData?.primaryList.filter(e => e.imgUrl).map(e => `${imageDomain}/${e.imgUrl}`)}
                hasClick={homePageData.primaryList.map(e => e.innId)}
            />
            <div style={{width: 'min(1440px, 100vw)', margin: 'auto'}}>
            <AboutUs
                aboutUsPicture={['/meguri/front/A.png', '/meguri/front/B.png', '/meguri/front/C.png']}
                aboutUsText={aboutUsText}
                styleType={styleType}
            />
            <Collection 
                collection={{
                    mainTitle: 'JUST ADDED',
                    subTitle: '新入選旅舍',
                    content: homePageData?.justAddedList
                }}
                id={'added'}
                styleType={styleType}
            />
            <Collection 
                collection={{ 
                    id: 'country',   
                    mainTitle: 'COUNTRYSIDE DESTINATIONS',
                    subTitle: '鄉野目的地',
                    content: homePageData?.countrysideList
                }}
                id={'country'}
                cardNeedTips={true}
                styleType={styleType}
            />
            <Experience
                experience={homePageData.tagList}
                styleType={styleType}
            />
            <QA styleType={styleType} questions={questions}/>
            <Contact styleType={styleType} contact={homePageContact}></Contact>
            </div>
            <Footer styleType={styleType}></Footer>
        </HomeWrapper>
    )
};



const AboutUs = ({aboutUsText, aboutUsPicture, styleType}) => {
    const pictureElements = aboutUsPicture.map((e,index) => {
        return <img className='lazyload' key={index} data-src={`${imageDomain}${e}`} alt='' style={{width: '100%'}}/>
    });

    const [ nowPage, setNowPage ] = useState(0);
    return (
        <AboutUsWrapper id='about' styleType={styleType}>
            <TitleText styleType={styleType}>
                <div className='main'>THE DIFFERENCE</div>
                <div className='sub'>甄選標準</div>
            </TitleText>
            <SwiperWrapper styleType={styleType}>
                <Swiper 
                    elements={pictureElements} 
                    isLoop={true} 
                    isAutoPlay={styleType !== STYLE_TYPE.MOBILE} 
                    height={styleType === STYLE_TYPE.MOBILE ? 201 : 441} 
                    time={7000}
                    arrowStyle={ARROW_STYLE.NONE} 
                    pointStyle={styleType === STYLE_TYPE.MOBILE ? POINT_STYLE.NONE :POINT_STYLE.CIRCLE_ROW}
                    setNowPage={setNowPage}
                />
            </SwiperWrapper>
            {styleType === STYLE_TYPE.MOBILE && (
                <RightTips styleType={styleType}>
                    <span>試試右滑</span>
                    <div id='w'><div id='arr'/><div id='line'/></div>
                </RightTips>)}
            <SwiperBackground styleType={styleType}/>
            <AboutUsTextWrapper  styleType={styleType}>
                {
                    aboutUsText.map((text, index) => {
                        if(index !== nowPage && styleType === STYLE_TYPE.MOBILE) return null;
                        return (
                            <Fragment key={index}>
                                <AboutUsMainText styleType={styleType} isNowPage={index === nowPage}>{text.main}</AboutUsMainText>
                                <AboutUsSubText styleType={styleType} isNowPage={index === nowPage}>{text.sub}</AboutUsSubText>
                            </Fragment>
                        );
                    })
                }
            </AboutUsTextWrapper>
            {styleType === STYLE_TYPE.MOBILE && 
                <YelloArrow styleType={styleType}>
                    <img src={yellow} alt=''></img>
                </YelloArrow>
            }
        </AboutUsWrapper>
    );
};

// const Collection = ({collection, styleType}) => {


//     return(
//         <CollectionWrapper id='collection'>
//            <TitleText styleType={styleType}>
//                 <div className='main'>just added</div>
//                 <div className='sub'>新入选旅舍</div>
//             </TitleText>
//             {
//                 ['select', 'new', 'town'].map((name) => {
//                     const getName = () => {
//                         switch(name) {
//                             case 'select': 
//                                 return '巡旅精选';
//                             case 'new': 
//                                 return '巡旅上新';
//                             case 'town':
//                                 return '巡旅小镇';
//                             default: return ''
//                         }
//                     }
//                     return (
//                         <Fragment key={name}>
//                             {/* <CollectionSubTitle id={name} styleType={styleType} category={name}>
//                                 <div/>
//                                 <span>{getName()}</span>
//                                 <div/>
//                             </CollectionSubTitle> */}
//                             { styleType === STYLE_TYPE.MOBILE && <CollectionFolder collectionSection={collection[name]}/>}
//                             { styleType !== STYLE_TYPE.MOBILE && <CollectionSwiper collectionSection={collection[name]}/>}
//                         </Fragment>
//                     )
//                 })
//             }
//         </CollectionWrapper>
//     );
// };

const Collection = ({collection, styleType, cardNeedTips, id}) => {
    return(
        <CollectionWrapper id={id}  styleType={styleType}>
           <TitleText styleType={styleType}>
                <div className='main'>{collection.mainTitle}</div>
                <div className='sub'>{collection.subTitle}</div>
            </TitleText>
            { styleType === STYLE_TYPE.MOBILE && <CollectionFolder collectionSection={collection.content} cardNeedTips={cardNeedTips}/>}
            { styleType !== STYLE_TYPE.MOBILE && <CollectionSwiper collectionSection={collection.content} cardNeedTips={cardNeedTips}/>}
        </CollectionWrapper>
    );
};

const CollectionSwiper = ({collectionSection, cardNeedTips}) => {
    const swiperElement = (items) => {
        let pages = [];
        for(let i = 0; i < items.length; i+=6) {
            if(i + 6 > items.length) {
                pages.push(
                    <Page key={i + 6} pageElements={items.slice(items.length - 6, items.length)} cardNeedTips={cardNeedTips} />
                )
            } else {
                pages.push(
                    <Page key={i} pageElements={items.slice(i, i+6)} cardNeedTips={cardNeedTips}/>
                );
            }
        }
        return pages;
    }
    return (
        <Swiper 
            height={554} 
            isAutoPlay={false} 
            pointStyle={POINT_STYLE.POINT} 
            arrowStyle={ARROW_STYLE.BIG_CIRCLE}  
            elements={swiperElement(collectionSection)} 
            isLoop={true}
            needAnimation={false}
        />
    );
}

const CollectionFolder = ({collectionSection, cardNeedTips}) => {
    const [ showNumber, setShowNumber ] = useState(3);
    const ele = useMemo(() => (collectionSection.map((e,index) => {
        return (
            <Card 
                key={index}
                cardPicSrc={`${imageDomain}/${e.coverImgUrl}`} 
                cardText={{main: `${e.title}-${e.name}` , sub: e.overview}} 
                cardTags={e.tagList.slice(0,2)}
                cardInnId={e.innId}
                cardTopTip={e.regionInfo}
                cardNeedTips={cardNeedTips}
            />
        );
    })), [collectionSection, cardNeedTips]);
    return (
        <Fragment>
            {ele.slice(0, showNumber)}
            {showNumber < collectionSection.length && (
            <SeeMore onClick={() => setShowNumber(e => e + 3)}>
                <span>查看更多</span>
                <div id='arrow'></div>
            </SeeMore>)}
        </Fragment>
    );
}

const Page = ({pageElements, cardNeedTips}) => {
    const ele = pageElements.map((e,index) => {
        return (
            <Card 
                key={index}
                cardPicSrc={`${imageDomain}/${e.coverImgUrl}`} 
                cardText={{main: `${e.title}-${e.name}`, sub: e.overview}} 
                cardTags={e.tagList.slice(0,2)}
                cardInnId={e.innId}
                cardTopTip={e.regionInfo}
                cardNeedTips={cardNeedTips}
            />
                
        );
    });
    return (
        <CollectionPageWrapper>
            <div key={'collection_1'}>{ele.slice(0,3)}</div>
            <div key={'collection_2'}>{ele.slice(3,6)}</div>
        </CollectionPageWrapper>
    );
};

const Card = ({cardPicSrc ,cardText, cardTags, cardInnId, cardNeedTips, cardTopTip}) => {
    const styleType = useContext(styleContextApp);
    const [ hover, setHover ] = useState(styleType === STYLE_TYPE.MOBILE);

    const enter = (e) => {
        setHover(true);
    };
    const leave = (e) => {
        setHover(false);
    };
    return(
        <Link to={`/detail/${cardInnId}`}>
            <CardWrapper styleType={styleType} onMouseEnter={enter} onMouseLeave={leave}>
                <CardPicWrapper>
                    <img  className='lazyload' data-src={cardPicSrc} alt=''/>
                </CardPicWrapper>
                {
                    hover && (
                        <Fragment>
                            <HoverCover/>
                            {/* {
                                cardNeedTips &&
                                    <CardTopTips styleType={styleType}>
                                        {cardTopTip}
                                    </CardTopTips>
                            } */}
                            <TagsWrapper styleType={styleType}>
                                {cardTags.map((ele, index) => {
                                    return (<CardTag styleType={styleType} key={index} type={'normal'}>{ele}</CardTag>);
                                })}
                                {
                                    cardNeedTips &&
                                        <CardTag styleType={styleType}  type={'toptips'}>
                                            {cardTopTip}
                                        </CardTag>
                                }
                            </TagsWrapper>
                            <CardTextWrapper styleType={styleType}>
                                <div className='main'>{cardText.main}</div>
                                <pre className='sub'>{cardText.sub}</pre>
                            </CardTextWrapper>
                        </Fragment>

                    )
                }
            </CardWrapper>
        </Link>
    )
};

const Experience = ({experience, styleType}) => {
    const cards = experience.map((ele, index) => <ExperienceCard key={index} ele={ele} styleType={styleType} />);
    return (
        <ExperienceWrapper styleType={styleType} id='find'>
            <TitleText styleType={styleType}>
                <div className='main'>CURATED COLLECTIONS</div>
                <div className='sub'>精選系列</div>
            </TitleText>
            <ExperienceSwiper  styleType={styleType}>
                <Swiper 
                    elements={cards} 
                    step={styleType !== STYLE_TYPE.MOBILE ? 33.77 : 100} 
                    isAutoPlay={false} 
                    isLoop={true} 
                    style2={{display: 'flex'}}
                    height={styleType !== STYLE_TYPE.MOBILE ? 670 : 482} 
                    loopStep={styleType !== STYLE_TYPE.MOBILE ? 3 : 1}
                    pointStyle={POINT_STYLE.NONE} 
                    arrowStyle={ARROW_STYLE.WHITE_CIRCLE}/>
                </ExperienceSwiper>
        </ExperienceWrapper>
    )
};

const ExperienceCard = ({ele, styleType}) => {
    const {location, name, title, description, imgUrl, id} = ele;
    if(!imgUrl) return null;
    return (
        <ExperienceCardWrapper styleType={styleType}>
            <ExCardPicture styleType={styleType}>
                <img className='lazyload' data-src={`${imageDomain}/${imgUrl}`} alt=''></img>
            </ExCardPicture>
            <Background styleType={styleType}/>
            <ExKeyWord styleType={styleType}> 
                {name.split('').map((e,index) => <div key={`${e}_${index}`}>{e}</div>)} 
            </ExKeyWord>
            <ExLocation styleType={styleType}> {location} </ExLocation>
            <ExTitle styleType={styleType}>{title}</ExTitle>
            <ExText styleType={styleType}>{description}</ExText>
            <Link to={`/explore/${id}`}>
                <ExButton styleType={styleType}>
                    <span>開始探索</span>
                    <div id='line'></div>
                    <div id='dot'></div>
                </ExButton>
            </Link>
        </ExperienceCardWrapper>
    );
};

const QA = ({questions, styleType}) => {
    return(
        <QAWrapper styleType={styleType} id='qa'>
            <TitleText styleType={styleType}>
                <div className='main'>ABOUT US</div>
                <div className='sub'>何為日本巡旅？</div>
            </TitleText>

            <QAText styleType={styleType}>
            在這個世界都是扁平的時代裡，沒有什麼比缺乏個性和千篇一律更讓人乏味。對本真的探索和對文化審美，自然環保的追求也讓新時代的旅人們在目的地與旅舍的挑選上有著更精細的高要求。日本巡旅，旨在圍繞在地精品旅舍，為旅人們提供一個更多元，更便捷，看得更深走得更遠的赴日出行平台。
            </QAText>
            <QAGuide styleType={styleType}>如有疑問請查閱下列常見問題列表</QAGuide>
            {
                questions.map((e, index) => (
                    <QABlock questionElement={e} key={index} styleType={styleType}/>
                ))
            }
        </QAWrapper>
    );
};

const QABlock = ({questionElement, styleType}) => {
    const { question, answer } = questionElement; 
    const [ showAnswer, setShowAnswer ] = useState(false);
    const onClick = () => {
        setShowAnswer(e => !e);
    };

    return (
        <Fragment>
        <QABlockWrapper styleType={styleType}>
            <Question styleType={styleType}>
                <div id='question_text'>{question}</div>
                <QuestionButton onClick={onClick} styleType={styleType} showAnswer={showAnswer}>
                    {showAnswer && <Clear sx={{height: '100%', width: '100%'}}></Clear>}
                    {!showAnswer && <Add sx={{height: '100%', width: '100%'}}></Add>}
                </QuestionButton>
            </Question>
        </QABlockWrapper>
        {showAnswer && (<Answer styleType={styleType}>{answer}</Answer>)}
        </Fragment>
    );
};

const Contact = ({contact, styleType}) => {
    const [showWechat, setShowWechat] = useState(false);
    const toShowWechat = () => {
        setShowWechat(true);
    }
    const wechatElement = useMemo(() => {
        return (
            <WechatWindow styleType={styleType} setShowMenu={setShowWechat} >
                <img src={wechat} alt=''></img>
            </WechatWindow>
        )
    }, [styleType]);
    return (
      <ContactWrapper styleType={styleType} id='contact'>
          <TitleText styleType={styleType}>
              <div className='main'>CONTACT</div>
              <div className='sub'>聯繫我們</div>
          </TitleText>
          <ContactIconWrapper styleType={styleType}>
              {contact.map(e => {
                  return <img   onClick={() => {
                      if(e !== SOCIAL_MEDIA_TYPE.WECHAT) {
                        window.open(SOCIAL_MEDIA_LINKS[e])
                      } else {
                        toShowWechat();
                      }
                }} className='lazyload' data-src={SOCIAL_MEDIA_LOGOS[e]} alt='' key={e} id={e}/>
              }) }
          </ContactIconWrapper>
          {showWechat && <Modal positionType={'middle'} modalElement={wechatElement} setModalOpen={setShowWechat} backdropClose={true}/>}
      </ContactWrapper>  
    );
};


const aboutUsText = [
    {main: '遠離都會', sub: '我們甄選日本各地隱與鄉野的小型獨立旅舍。她們或是藏在山間、矗立於海島、甚至可能混跡於村落的煙火氣息中。'},
    {main: '洞察生活', sub: '每間旅舍都是一扇洞察在地風土的窗口。她們通過對當代生活方式的探索，在古老的傳統和可持續旅遊之間找到平衡。'},
    {main: '享受靜好', sub: '旅舍依靠個性和旅人的共情來維繫彼此之間的連接。沒有了奢侈浮華的符號消費，剩下的就是盡情享受片刻的靜好。'}
]


const questions = [
    {question: '在地精品旅舍的定義為何？', answer: '原則上遠離都會及熱門觀光景點，客房數量不多於20間。剔除流水線式的複製旅舍，原則上均為主理人或在地公司獨立運營。作為深入當地的旅行據點，擁有強烈個性，能夠闡釋當地特有的生態環境，生活文化美學，以及踐行可持續出行的理念。'},
    {question: '是否所有旅舍均提供奢華度假體驗？', answer: '因並非純粹基於硬件設施及舒適度選擇，一部分旅舍所提供的服務也與傳統度假旅捨不盡相同，望海涵。'},
    {question: '日本巡旅是否提供旅舍預定服務？', answer: '日本巡旅並不直接為旅人提供訂房服務。作為平台內旅舍面向大中華圈提供服務時所指定的合作夥伴，我們將在接到您的入住意向後，協助您向旅舍確認包括空房情況在內的各類信息，輔助您順利完成預約支付及下榻。'},
    {question: '日本巡旅是否提供定制服務？', answer: '如果您還未決定目的地，我們很樂意根據您的興趣，愛好和品位為您推薦在地精品旅舍。如果您已經完成特定旅舍的預約流程，我們會基於每棟旅舍詳情頁內列出的推薦體驗及去處協助您制定慢旅行行程。'},
]
